import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { Template } from 'src/app/models/template.model';
import { ReferenceType } from 'src/app/models/reference-types.model';
import { Reference } from 'src/app/models/reference.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { Category } from 'src/app/models/category.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit, OnDestroy {

  route$: any;
  reference: Reference = null;
  reference$: any;
  referenceTypes: Array<ReferenceType> = null;
  referenceTypes$: any;
  template: Template = null;
  template$: any;
  loadingReference = false;
  referenceType: ReferenceType = null;
  loadingTemplate = false;
  ckeConfig: any;
  saving = false;
  error = null;
  imageSrcs = [];
  categories: Array<Category> = [];
  cat$ = null;
  lang: any;
  lang$: any;

  @ViewChild('myckeditor') ckeditor: any;

  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    private router: Router,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit() {
    this.cat$ = this.appService.categories.subscribe((c) => {
      this.categories = c;
    });
    this.ckeConfig = {
      allowedContent: false,
      forcePasteAsPlainText: true,
      removeButtons: 'Image'
    };
    this.route$ = this.route.params.subscribe(params => {
      if (params.referenceId) {
        this.getReference(params.referenceId);
      }
    });
    this.reference$ = this.appService.reference.subscribe((r) => {
      this.reference = r;
      if (r) {
        this.initCheckBoxes();
      }
    });
    this.referenceTypes$ = this.appService.referenceTypes.subscribe((r) => {
      this.referenceTypes = r;
    });
    this.template$ = this.appService.template.subscribe((r) => {
      this.template = r;
    });
    this.lang$ = this.appService.selectedLang.subscribe((l) => {
      if (l) {
        if (this.lang !== l) {
          this.lang = l.toUpperCase();
          if (this.reference) {
            console.log('Test');
            console.log('Type: ', this.referenceType);
            if (this.reference.referenceDocumentId) {
              this.getReference(this.reference.referenceDocumentId);
            } else {
              this.onChangeReferenceType();
            }
          }
        }
      }
    });
    this.getReferenceTypes();
  }

  ngOnDestroy() {
    this.cat$.unsubscribe();
    this.route$.unsubscribe();
    this.reference$.unsubscribe();
    this.referenceTypes$.unsubscribe();
    this.template$.unsubscribe();
    this.lang$.unsubscribe();
  }

  getReference(referenceId) {
    this.loadingReference = true;
    this.appService.getReference(referenceId).subscribe(
      () => {
        this.loadingReference = false;
      }
    );
  }

  getReferenceTypes() {
    this.loadingReference = true;
    this.appService.getReferenceTypes().subscribe(
      () => {
        this.loadingReference = false;

      }
    );
  }

  onChangeReferenceType() {
    this.loadingTemplate = true;
    this.appService.getTemplateByReferenceType(this.referenceType.referenceTypeId).subscribe(
      (t) => {
        this.template = t;
        this.loadingTemplate = false;
        const temp = t;
        temp.referenceTypeId = this.referenceType.referenceTypeId;
        this.appService.reference.next(temp);
        // this.referenceType = null;
      }
    );
  }

  initCheckBoxes() {
    this.reference.groups.forEach((g) => {
      if (g.referenceFunctionGroupId !== 1) {
        g.functions.forEach((f) => {
          if (f.clientDisplayType === 'string') {
            f.isChecked = f.value ? true : false;
          }
        });
      }
    });
  }

  onCheckedChange(f, event) {
    if (!f.isChecked) {
      f.value = null;
    }
  }


  onCancel() {
    if (window.confirm('Möchten Sie Ihre Änderungen verwerfen?')) {
      this.router.navigateByUrl('/references/search');
    }
  }

  isRequiredFunctionId(functionId) {
    const requiredFunctionIds = [1];
    return requiredFunctionIds.filter((x) => x === functionId).length > 0;
  }

  onSubmit(f) {
    if (!f.form.valid) {
      this.snackbar.open('Nicht gespeichert. Bitte Eingaben überprüfen!', null, {
        duration: 5000
      });
      return;
    }
    this.prepareImages();
    f.form.disable();
    if (this.reference.referenceDocumentId) {
      this.update(f);
    } else {
      this.create(f);
    }
  }

  update(f) {
    this.saving = true;
    this.appService.updateReference(this.reference).subscribe((data) => {
      f.form.enable();
      this.saving = false;
      this.snackbar.open('Referenz gespeichert', null, {
        duration: 5000,
        panelClass: 'snack-success'
      });
    }, (error) => {
      f.form.enable();
      this.snackbar.open('Fehler beim speichern!', null, {
        duration: 5000,
        panelClass: 'snack-error'
      });
      this.saving = false;
      this.error = error;
    });
  }

  create(f) {
    this.saving = true;
    this.appService.createReference(this.reference).subscribe((data) => {
      f.form.enable();
      this.saving = false;
      this.snackbar.open('Referenz erstellt', null, {
        duration: 5000,
        panelClass: 'snack-success'
      });
    }, (error) => {
      f.form.enable();
      this.snackbar.open('Fehler beim speichern!', null, {
        duration: 5000,
        panelClass: 'snack-error'
      });
      this.saving = false;
      this.error = error;
    });
  }

  handleFileInputChange(e) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    const pattern = /image-*/;
    const reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    const reader = e.target;
    const imageSrc = reader.result;
    this.imageSrcs.push(imageSrc);
  }

  prepareImages() {
    this.reference.images = null;
    this.reference.images = [];
    for (let i = 0; i < this.imageSrcs.length; i++) {
      const img = this.imageSrcs[i];
      let contentType = '';
      if (img.search('image/png') > 0) {
        contentType = 'image/png';
      } else if (img.search('image/jpg') > 0) {
        contentType = 'image/jpg';
      } else if (img.search('image/jpeg') > 0) {
        contentType = 'image/jpeg';
      }
      const image = {
        filename: 'img-' + i + '.' + contentType.split('/')[1],
        contentType,
        content: img.split(',')[1]
      };
      this.reference.images.push(image);
    }
    this.imageSrcs = null;
    this.imageSrcs = [];
  }

  deleteImage(image) {
    image.deleting = true;
    this.appService.deleteReferenceImage(image.referenceImageId).subscribe(
      () => {
        image.deleting = false;
        this.reference.images.splice(this.reference.images.indexOf(image), 1);
      }, (error) => {
        image.deleting = false;
      }
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.reference.images, event.previousIndex, event.currentIndex);
  }


}
